import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { TeethExtraction } from 'types/TreatmentPlanning.types';

import ToothChart from './ToothChart';

type RhfTeethToExtractProp = {
  isBaby: boolean;
  name: string;
  title?: string;
  showError?: boolean;
  disabled?: boolean;
  animateLabel?: string;
  source?: string;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
  isToothChartRestricted?: boolean;
  isCrowdExtraction?: boolean;
  restrictedToothChartValue?: TeethExtraction;
};
const RhfTeethToExtract: FC<RhfTeethToExtractProp> = ({
  isBaby,
  name,
  title,
  showError = true,
  disabled = false,
  animateLabel,
  source,
  isUpperDisabled,
  isLowerDisabled,
  isToothChartRestricted,
  isCrowdExtraction,
  restrictedToothChartValue
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <ToothChart
          isToothChartRestricted={isToothChartRestricted}
          isBaby={isBaby}
          source={source}
          title={title}
          value={field.value}
          onChange={field.onChange}
          name={name}
          error={error?.message}
          showError={showError}
          disabled={disabled}
          animateLabel={animateLabel}
          isUpperDisabled={isUpperDisabled}
          isLowerDisabled={isLowerDisabled}
          isCrowdExtraction={isCrowdExtraction}
          restrictedToothChartValue={restrictedToothChartValue}
        />
      )}
    />
  );
};

export default RhfTeethToExtract;
